import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environment';

import { Nutrients } from '../models';

@Injectable({
  providedIn: 'root',
})
export class NutrientService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/ruminants-service/nutrition/nutrients';

  constructor() {}

  getNutrients(): Observable<Nutrients> {
    return this.http.get<Nutrients>(`${this.baseUrl}/catalog`);
  }
}
